<template>
  <div class="accessIndex">

    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5 class="head_contain">
            <p class="table_card__head--title">
              Asistencias por entrenador
            </p>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <div
              class="buttom_reload"
              @click="pagination_query=false;getTrainers(true);date_available=false;"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <div 
          class="accessIndex__access_items--date_container_generic user__container--class_date_separator table_card__body"
        >
          <app-date-picker v-if="date_available"
            @filterQuery="pagination_query=false;getTrainers(false,$event);"></app-date-picker>
        </div>
        <v-data-table
          :headers="headers"
          :items="trainers"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props" >
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.total_redemptions }}</td>
          </template>
        </v-data-table>
        <div v-if="trainers.length>0&& pages > 1" class="accessIndex__pagination">
          <v-pagination  color="light-blue darken-3" v-model="pagination.page" :length="pages"></v-pagination>
          <label class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
          <label class="accessIndex__pagination--current_text" v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}</label>
          <label class="accessIndex__pagination--current_text" v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
        </div>
      </div>
    </div>


    
  </div>


</template>

<script>
export default {
  data () {
    return {
      pagination_query:false,
      date_available:false,
      invitations_size:0,
      pages:2,
      pagination: {page:1,rowsPerPage:24},
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      trainers: [],
      headers: [
          { text: 'Nombre', sortable: true, value: 'title' },
          { text: 'Canjes', value: 'redemptions', sortable: true }
      ],
    }
  },
  mounted(){
    this.getTrainers(true);
  },
  watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
       else if(oldVal!=val&&val!=null&&oldVal!=null){
         this.pagination_query=true;
         this.getTrainers(false);

       }

       }
    },
  methods: {
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    monthEarlier(){
      var datex=new Date();
      datex.setMonth(datex.getMonth() - 1);
      return datex.toISOString().substr(0, 10);
    },
    getTrainers(defaultOption,dates){
      if(!this.pagination_query){
        this.pagination.page=1;
      }

      var initialDate=this.monthEarlier();
      var lastDate=new Date().toISOString().substr(0, 10);
      if(!defaultOption){

        var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' };
        if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
          this.date = this.modifyDateFormatToStatus(object.date_from);
          this.date2 = this.modifyDateFormatToStatus(object.date_to);
        }
        initialDate=this.date;
        lastDate=this.date2;
      }
      else{
        this.date= this.monthEarlier();
        this.date2= new Date().toISOString().substr(0, 10);
      }
      try {
        this.$http.get('classes/trainers',
        {
          params:{
            offset_time: new Date().getTimezoneOffset(),
            first_date: initialDate,
            last_date: lastDate,
            page:this.pagination.page
          },
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()
          }
         })
        .then(function(response){
          this.trainers = response.body.data;
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          this.date_available=true;
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
        } catch (e) {
          alert(e.message)
        }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/classes/Index_trainers_redemptions.vue